<template>
  <div class='audioPlayer'>
    <i class='playBtn zmdi zmdi-play' v-if='this.playing' :id='message.callid' @click='playPauseAudio($event)'></i>
    <i class='playBtn zmdi zmdi-pause' v-else :id='message.callid' @click='playPauseAudio($event)'></i>

    <label :id='message.callid' class='small waveform_counter' ref='counter'>{{this.currentTime}}</label>

    <div class='waveWrapper'>
      <div :id='message.callid' class='waveform' ref='waveform'></div>
    </div>

    <label :id='message.callid' class='small waveform_duration' ref='duration'></label>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import * as AWS from 'aws-sdk'
import WaveSurfer from 'wavesurfer.js'
import 'url-polyfill'

export default {
  name: 'audio_player',
  props: ['message', 'audio', 'trueDuration', 'floatDuration', 'currentTime'],
  data: function () {
    return {
      wavesurfer: undefined,
      waveFormDuration: undefined,
      waveFormCounter: undefined,
      playing: false,
      fakeIeTime: 0,
      loaded: false
    }
  },
  computed: {
    ...mapState({
      waveformsArray: state => state.waveformsArray,
      conversation: state => state.conversation,
      user: state => state.user,
    }),
  },
  mounted: function () {
    let audioFile = this.audio.audiofileembed
    this.authAudio(audioFile)
    
    window.addEventListener('resize', this.resizeAudio)

    // Prevent audio duplication
    this.$root.$on('audioClicked', callid => {
      if(callid != this.message.callid) {
        this.wavesurfer.pause()
        this.playing = false
      }
    });

    // Also, kill audio on conversation change
    this.$root.$on('convoSelected', () => {
      this.wavesurfer.pause()
      this.playing = false
    })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.resizeAudio)
    this.wavesurfer.destroy();
  },
  methods: {
    resizeAudio: function () {
      this.waveformsArray.forEach(x => {
        x.drawBuffer()
      })
    },
    authAudio: async function (audioFile) {

      this.renderWaveForm(audioFile)
    },
    renderWaveformIE: function (url) {
      let domEl = document.createElement('div');
      document.getElementsByClassName('waveform').appendChild(domEl);

      let domEl2 = document.createElement('span');
      domEl2.className = "counter_text";
      document.getElementsByClassName('waveform_counter').appendChild(domEl2);
      $(domEl2).text("0:00");


      swfobject.embedSWF('wavesurfer.swf', 'myWaveSurferId', '100%', '128', '11.1.0', 'expressInstall.swf', {id: domEl}, {allowScriptAccess: 'always'}, {});

      let wavesurfer = new WaveSurfer.Swf(domEl);
      wavesurfer.on('init', function() {
        wavesurfer.init({
            cursorWidth: 0,
            progressColor: '#1394d7',
            waveColor: '#9b9b9b'
        });
      });

      let random = Math.random(1*1000);

      wavesurfer.load(url + '&X-Amz-Algorithm=AWS4-HMAC-SHA256');
      waveformsArray.push(wavesurfer);

      // Show current time
      let waveAudioProcess = wavesurfer.on('audioprocess', function () {
          $(domEl2).text(formatTime(wavesurfer.backend.getCurrentTime()));
          if($(domEl2).text() === $(domEl3).text()) {
            var playPauseBTN = $(domEl2).closest(".audio_player").find(".playPause");
            $(playPauseBTN).attr('src', 'images/play-btn.png');
            $(playPauseBTN).addClass('play');
          }
      });
      // Show clip duration
      let waveDuration = wavesurfer.on('ready', function () {
          $(domEl3).text(formatTime(wavesurfer.backend.getDuration()));
      });

      waveformsCounter.push(waveAudioProcess);
      waveformsDurations.push(waveDuration);
    },
    renderWaveForm: function (url) {
      let domWave = document.createElement('div')
      domWave.className = 'wave-center'

      let domDiv = document.createElement('div')

      let target = this.$refs.waveform
      target.innerHTML = ''
      target.appendChild(domWave)
      target.appendChild(domDiv)

      let domCounter = document.createElement('span')
      domCounter.className = 'counter_text'

      let target2 = this.$refs.counter
      target2.innerHTML = ''
      target2.appendChild(domCounter)
      $(domCounter).text('0:00')

      let domDur = document.createElement('span')
      domDur.className = 'duration_text'

      let target3 = this.$refs.duration
      target3.innerHTML = ''
      target3.appendChild(domDur)

      let ua = window.navigator.userAgent
      let msie = ua.indexOf('MSIE ')

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv11./) || ua == 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko' || ua == 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; McAfee; rv:11.0) like Gecko' ) {
          //build new audio player for IE only
          var callIDIE = target.id
          $('.wave-center').css({'height': '100%', 'background-color': '#007def', 'width': '0% ', 'float': 'left', 'top': '0%', 'position': 'relative'})
          $('.waveform').filter('#' + callIDIE).css({'background-color': '#bfbfbf', 'height': '10px', 'margin-top': '1.5%'});
          $('.waveform').filter('#' + callIDIE).children().css({'height': '100% !important', 'background-color': '#007def !important', 'width': '20% !important', 'float': 'left !important', 'top': '0%', 'position': 'relative'})
          $('.waveform').filter('#' + callIDIE).children().attr('id', callIDIE)
          $('.waveform').filter('#' + callIDIE).append('<audio id = "ieAudio' + callIDIE  +'" preload ="metaata" src="' + url +'"></audio>')
          $('.waveform_duration').filter('#'+  callIDIE).append('<span class="duration_text">' +  this.trueDuration + '</span>')
          $('.waveform_counter').filter('#' + callIDIE).css('display', 'none')

      } else {
        let options = {
          container: domDiv,
          cursorWidth: 0,
          barHeight: 3,
          barWidth: 2,
          height: 31,
          hideScrollbar: true,
          minPxPerSec: 30,
          normalize: true,
          responsive: true,
          progressColor: '#1394d7',
          waveColor: '#9b9b9b',
          xhr: {
            cache: "default",
            mode: "cors",
            method: "GET",
            headers: [
              { key: "cache-control", value: "no-cache" },
              { key: "pragma", value: "no-cache" }
            ]
          }
        }
        
        let random = Math.random(1*1000);
        this.wavesurfer = WaveSurfer.create(options)
        this.wavesurfer.load(url + '&X-Amz-Algorithm=AWS4-HMAC-SHA256')
        this.loaded = true
      }
      let counter = this.wavesurfer.on('audioprocess', () => {
        $(domCounter).text(this.formatTime(this.wavesurfer.backend.getCurrentTime()))
      })

      let duration = this.wavesurfer.on('ready', () => {
        $(domDur).text(this.formatTime(this.wavesurfer.backend.getDuration()))
      })

      this.waveFormCounter = counter
      this.waveFormDuration = duration

      let that = this
      this.wavesurfer.on('ready', () => {
        that.loaded = true;
        that.playPauseAudio()
      })
    },
    formatTime: function (time) {
      return [
        Math.floor((time % 3600) / 60),
        ('00' + Math.floor(time % 60)).slice(-2)
      ].join(':')
    },
    playPauseAudio: function (event) {
      let ua = window.navigator.userAgent
      let msie = ua.indexOf('MSIE ')
      this.$root.$emit('audioClicked', this.message.callid);
      this.playing = !this.playing
      if (this.playing) {
        let endpoint = 'calls/logListen/' + this.message.callid
        let res = this.axios.post(endpoint, {
          leuserid: this.user.leuserid
        })
      }
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv11./) || ua == 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko' || ua == 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; McAfee; rv:11.0) like Gecko' ) {    
          if ($(event.target).hasClass('pause')) {
            var targetid  =   $(event.target).attr('id')
              $('#ieAudio' + targetid)[0].play()
              var durationInMS = this.floatDuration * 1000
              $('.wave-center').filter('#' + targetid).animate({width: '100%'}, durationInMS)
              $(event.target).attr('src', this.playBtn)
              $(event.target).removeClass('pause')
              $('.waveform_counter').filter('#' + targetid).css('display', 'none')
          } else { 
              var targetid  =  $(event.target).attr('id')
              $('.wave-center').filter('#' + targetid).stop()
              $('#ieAudio' + targetid)[0].pause()
              $(event.target).attr('src', this.pauseBtn)
              $(event.target).addClass('pause')
          }
      }
      this.wavesurfer.playPause()

    },
    updateTimeIE: function(event){

    },
    checkAudio: function () {
      let audioState = this.conversation.audioState

      if (audioState === 'new') {
        this.compileAudio()
      } else if (audioState.constructor === Array) {
        this.loadAudio(audioState)
      }
    },
  }
}
</script>